import jsonSchemaDefaults from "./json-schema";
import typeDefDefaults from "./type-def";

const defaults = {
  "json-schema": jsonSchemaDefaults,
  "type-def": typeDefDefaults
};

export default defaults